var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNegativeNotificationIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 2.16797C5.67312 2.16797 2.16602 5.67507 2.16602 10.0013C2.16602 14.3275 5.67312 17.8346 9.99935 17.8346C14.3256 17.8346 17.8327 14.3275 17.8327 10.0013C17.8327 5.67507 14.3256 2.16797 9.99935 2.16797ZM1.16602 10.0013C1.16602 5.12279 5.12083 1.16797 9.99935 1.16797C14.8779 1.16797 18.8327 5.12279 18.8327 10.0013C18.8327 14.8798 14.8779 18.8346 9.99935 18.8346C5.12083 18.8346 1.16602 14.8798 1.16602 10.0013ZM9.99935 6.16797C10.2755 6.16797 10.4993 6.39183 10.4993 6.66797V10.8346C10.4993 11.1108 10.2755 11.3346 9.99935 11.3346C9.72321 11.3346 9.49935 11.1108 9.49935 10.8346V6.66797C9.49935 6.39183 9.72321 6.16797 9.99935 6.16797Z",
    fill: "#D12D36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8327 13.3346C10.8327 13.7949 10.4596 14.168 9.99935 14.168C9.53911 14.168 9.16602 13.7949 9.16602 13.3346C9.16602 12.8744 9.53911 12.5013 9.99935 12.5013C10.4596 12.5013 10.8327 12.8744 10.8327 13.3346Z",
    fill: "#D12D36"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNegativeNotificationIcon);
export default ForwardRef;